import { useContext, useEffect, useState } from "react";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import { Col, Row, Table } from "react-bootstrap";
import { translate, translateNumber } from "../../../helper";
import LangContext from "../../../contexts/LangContext";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

const DataTable = (props) => {
  const { lang } = useContext(LangContext);
  const isCardView = props.view === "cards";
  const [row, setRow] = useState(10);
  const [page, setPage] = useState(1);
  const [key, setKey] = useState("");
  const [sort, setSort] = useState(props.sort);
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState(0);

  useEffect(() => {
    if (props.data.length > 0) {
      setSearchData(props.data.length);
    }
    const searchKeyElem = document.querySelector(".sh-datatable-filter .sh-input-desh");

    let newData = props.data;
    if (searchKeyElem) {
      const key = searchKeyElem.value;
      newData = newData.filter((d) => {
        let found = false;
        for (let i = 0; i < props.filterColumn.length; i++) {
          found = found || d[props.filterColumn[i]].toLowerCase().includes(key.toLowerCase());
        }
        return found;
      });
    }
    setData(newData.filter((d, i) => i < 10));
    const tbodyCell = document.querySelector(".tbody-td");
    if (tbodyCell) {
      const colspan = Number(tbodyCell.getAttribute("colspan") || 0);
      if (colspan > 1) {
        tbodyCell.style.textAlign = "center";
      }
    }
  }, [props]);

  const handleFilterChange = (key) => {
    let newData = props.data.filter((d) => {
      let found = false;
      for (let i = 0; i < props.filterColumn.length; i++) {
        found = found || d[props.filterColumn[i]].toLowerCase().includes(key.toLowerCase());
      }
      return found;
    });
    setSearchData(newData.length);
    newData = newData.filter((d, i) => i >= (page - 1) * row && i < page * row);
    newData = newData.filter((d, i) => i < row);
    setData(newData);
    setKey(key);
  };

  const handleRowsNumberChange = (row) => {
    let newData = props.data.filter((d) => {
      let rowData = "";
      props.filterColumn.forEach((rd) => (rowData += d[rd]));
      return rowData.toLowerCase().includes(key.toLowerCase());
    });
    newData = newData.filter((d, i) => i >= (page - 1) * row && i < page * row);
    newData = newData.filter((d, i) => i < row);
    setRow(row);
    setData(newData);
  };

  const handlePageChange = (page) => {
    let newData = props.data.filter((d) => {
      let rowData = "";
      props.filterColumn.forEach((rd) => (rowData += d[rd]));
      return rowData.toLowerCase().includes(key.toLowerCase());
    });
    newData = newData.filter((d, i) => i >= (page - 1) * row && i < page * row);
    newData = newData.filter((d, i) => i < row);
    setPage(page);
    setData(newData);
  };

  const handleSortChange = (sort) => {
    let newData = props.data.filter((d) => {
      let rowData = "";
      props.filterColumn.forEach((rd) => (rowData += d[rd]));
      return rowData.toLowerCase().includes(key.toLowerCase());
    });
    newData = newData.filter((d, i) => i >= (page - 1) * row && i < page * row);
    newData = newData.filter((d, i) => i < row);

    let prop = sort.prop;
    if (sort.prop === "name") {
      prop = "name_en";
    } else if (sort.prop === "sn") {
      prop = "sn_en";
    }

    newData = newData.sort((a, b) => {
      if (sort.order === "asc") {
        if (b[prop] > a[prop]) return 1;
        else return -1;
      } else {
        if (b[prop] < a[prop]) return 1;
        else return -1;
      }
    });
    setData(newData);
    setSort(sort);
  };

  return (
    <div className="sh-datatable-modern">
      <DatatableWrapper body={data} headers={props.headers}>
        <Row className="mb-4 sh-datatable-toolbar">
          <Col xs={12} md={12} lg={3} className="sh-datatable-filter d-flex flex-col justify-content-end align-items-end">
            <Filter
              placeholder={translate("search", lang)}
              classes={{ clearButton: "sh-btn-desh", input: "sh-input-desh" }}
              controlledProps={{
                filter: key,
                onFilterChange: handleFilterChange,
              }}
            />
          </Col>
          <Col xs={6} md={2} lg={2} className="sh-row-per-page d-flex flex-col align-items-end">
            <PaginationOptions
              labels={{ beforeSelect: translate("table_size") }}
              classes={{ formControl: "sh-select-desh", formText: "sh-page-option" }}
              controlledProps={{
                filteredDataLength: data.length,
                onRowsPerPageChange: handleRowsNumberChange,
                rowsPerPage: row,
                rowsPerPageOptions: [10, 20, 30, 50, 100],
              }}
            />
          </Col>
          <Col xs={6} md={4} lg={4} className="sh-total-record-wrapper d-flex flex-col align-items-end">
            <div className="sh-total-record">
              {translate("total_record", lang)} - {translateNumber(searchData, lang)}/{translateNumber(props.data.length, lang)}
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} className="sh-pagination d-flex justify-content-end align-items-end">
            <Pagination
              labels={{ firstPage: translate("first", lang), prevPage: translate("prev", lang), nextPage: translate("next", lang), lastPage: translate("last", lang) }}
              classes={{ buttonGroup: "sh-btn-desh sh-nav-desh", button: "sh-btn-desh sh-nav-desh" }}
              controlledProps={{
                currentPage: page,
                maxPage: searchData % row === 0 ? parseInt(searchData / row) : parseInt(searchData / row) + 1,
                onPaginationChange: handlePageChange,
              }}
            />
          </Col>
        </Row>
        {isCardView ? (
          <div className="sh-card-list-wrapper">
            {data.length === 0 ? (
              <div className="sh-card-list-empty">{translate("no_record_found", lang)}</div>
            ) : (
              data.map((rowItem, index) => (
                <div className="sh-card-list-item" key={rowItem.sn_en || index}>
                  <div className="sh-card-list-item-sn">{rowItem.sn}</div>
                  <div className="sh-card-list-item-body">{rowItem.candidate}</div>
                  <div className="sh-card-list-item-vote">{rowItem.vote}</div>
                </div>
              ))
            )}
          </div>
        ) : (
          <Table responsive className="sh-table-modern">
            <TableHeader
              controlledProps={{
                filteredDataLength: data.length,
                onSortChange: handleSortChange,
                sortState: sort,
              }}
            />
            <TableBody labels={{ noResults: translate("no_record_found", lang) }} />
          </Table>
        )}
      </DatatableWrapper>
    </div>
  );
};

export default DataTable;
